import { merge } from '../../../helper';

import type { CustomFile } from '../types';

import type { TypeUploadConfig, TypeUploadResultPromise } from './types';
import createUploadController from './createUploadController';
import createUploadContext from './createUploadContext';
import uploadBatchFiles from './uploadBatchFiles';

// ----------------------------------------------------------------------------

/*
 * Batch mode: every file travels in one request, so the whole set succeeds or fails
 * together and per-file progress is interpolated from that single upload stream.
 */
function sendBatchFiles(files: CustomFile[], config: TypeUploadConfig): TypeUploadResultPromise {
    const defConfig = merge({}, config);

    const context = createUploadContext(files);
    const promise = uploadBatchFiles(files, defConfig, context);
    const controller = createUploadController(context);

    return { promise, controller };
}

// ----------------------------------------------------------------------------

export default sendBatchFiles;
